import { type FieldFunctionOptions } from "@apollo/client"
import { type KeyArgsFunction } from "@apollo/client/cache/inmemory/policies"
import {
  type AuditLogEvent,
  type AuditLogPage,
  type QueryReadAuditLogArgs,
  type QueryReadAuditLogEventArgs,
} from "@digits-graphql/frontend/graphql-bearer"
import { allKeyArgs } from "src/shared/initializers/typePolicies/helpers/allKeyArgs"

// Cursor pages share a cache entry only within the same anchored filter.
const PAGE_EXCLUDED_KEYS = ["limit", "cursor"]

const pageKeyArgs: KeyArgsFunction = (args, context) =>
  args ? allKeyArgs(args, PAGE_EXCLUDED_KEYS) : context.fieldName

export function auditLogPagePagination() {
  return {
    keyArgs: pageKeyArgs,
    merge(
      existing: AuditLogPage | undefined,
      incoming: AuditLogPage,
      { args }: FieldFunctionOptions<QueryReadAuditLogArgs>
    ): AuditLogPage {
      if (!existing || !args?.cursor) return incoming
      if (existing.pageAnchor !== incoming.pageAnchor || args.cursor !== existing.nextCursor) {
        return existing
      }
      return { ...incoming, events: [...existing.events, ...incoming.events] }
    },
  }
}

// The event query pages its references. A later page appends them onto the event held.
export function auditLogEventReferencesPagination() {
  return {
    keyArgs: ["legalEntityId", "id"],
    merge(
      existing: AuditLogEvent | null | undefined,
      incoming: AuditLogEvent | null,
      { args }: FieldFunctionOptions<QueryReadAuditLogEventArgs>
    ): AuditLogEvent | null {
      if (!existing || !incoming || (args?.referencesPage?.offset ?? 0) === 0) {
        return incoming
      }
      return {
        ...incoming,
        references: [...existing.references, ...incoming.references],
      }
    },
  }
}
